<script setup lang="ts">
import { NSlider } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: number | number[]
  defaultValue?: number | number[]
  min?: number
  max?: number
  step?: number
  range?: boolean
  reverse?: boolean
  disabled?: boolean
  readonly?: boolean
  showTooltip?: boolean
  showMark?: boolean
  marks?: Record<number, string>
  formatTooltip?: (value: number) => string
  tooltip?: boolean
  placement?: 'top' | 'bottom'
  onUpdateValue?: (value: number | number[]) => void
  onChange?: (value: number | number[]) => void
  onUpdateShowTooltip?: (showTooltip: boolean) => void
}>(), {
  value: undefined,
  defaultValue: 0,
  min: 0,
  max: 100,
  step: 1,
  range: false,
  reverse: false,
  disabled: false,
  readonly: false,
  showTooltip: true,
  showMark: false,
  marks: undefined,
  formatTooltip: undefined,
  tooltip: true,
  placement: 'top',
})

const emit = defineEmits<{
  'update:value': [value: number | number[]]
  'change': [value: number | number[]]
  'update:show-tooltip': [showTooltip: boolean]
}>()

const attrs = useAttrs()

const onUpdateValue = (value: number | number[]) => {
  emit('update:value', value)
}

const onChange = (value: number | number[]) => {
  emit('change', value)
}

const onUpdateShowTooltip = (showTooltip: boolean) => {
  emit('update:show-tooltip', showTooltip)
}
</script>

<template>
  <NSlider
    :value="value"
    :default-value="defaultValue"
    :min="min"
    :max="max"
    :step="step"
    :range="range"
    :reverse="reverse"
    :disabled="disabled"
    :readonly="readonly"
    :show-tooltip="showTooltip"
    :show-mark="showMark"
    :marks="marks"
    :format-tooltip="formatTooltip"
    :tooltip="tooltip"
    :placement="placement"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @change="onChange"
    @update:show-tooltip="onUpdateShowTooltip"
  />
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
